/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function ActorEditViewController(this: JS5Object, $routeParams: JS5Object, $route: JS5Object, $location: JS5Object,
                                 $timeout: JS5Function, CollaboratorsService: JS5Object, BreadcrumbService: JS5Object,
                                 _: JS5Object, ModalService: JS5Object) {

    this.actorIsSelf = false;
    let contentPathParam = (this.isSeries) ? 'series' : 'movies';

    const initializeBreadcrumbs = () => {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: $route.current.label,
            location: $route.current.rootRoute
        });

        BreadcrumbService.addBreadcrumb({
            name: this.contentName,
            location: `/meta/${contentPathParam}/edit/${$routeParams.id}/collaborators`
        });
    };

    const getData = () => {
        this.loadingIndicator.show = true;
        CollaboratorsService.getCollaboratorRole({id: $routeParams.actorId}).then((data: JS5Object) => {
            this.editData = _.cloneDeep(data);
            this.actorIsSelf = _.isEqual(_.get(this.editData, 'character'), 'Self');
            _.set(CollaboratorsService, 'originalEditData', angular.copy(this.editData));
            this.loadingIndicator.show = false;
        });
    };
    this.saveEditData = () => {
        this.loadingIndicator.show = true;
        // If the Self checkbox is set, set the character property to the string 'Self'
        if (this.actorIsSelf) {
            _.set(this.editData, 'character', 'Self');
        }
        saveCollaboratorRole();
    };

    const saveCollaboratorRole = () => {
        if (isThisActorNew()) {
            createNewRole();
        } else {
            updateExistingRole();
        }
    };

    const updateExistingRole = () => {
        CollaboratorsService.updateCollaboratorRole(this.editData).then((data: JS5Object) => {
            CollaboratorsService.originalEditData = _.cloneDeep(data);
            this.loadingIndicator.show = false;
            this.editorForm.$setPristine();
        }).catch(() => {
            this.handleDuplicateRole();
        });
    };

    const createNewRole = () => {
        CollaboratorsService.saveContentActor({id: $routeParams.id}, this.editData).then((data: JS5Object) => {
            CollaboratorsService.originalEditData = _.cloneDeep(data);
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
            $location.url(`/meta/${contentPathParam}/edit/${$routeParams.id}/collaborators`);
        });
    };
    this.handleDuplicateRole = () => {
        _.set(this, 'actorIsSelf', _.isEqual(_.get(CollaboratorsService.originalEditData, 'character'), 'Self'));
        this.loadingIndicator.show = false;
    };

    const isThisActorNew = () => {
        return _.isEqual(_.toInteger($routeParams.actorId), -1);
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => this.editorForm && this.editorForm.$dirty,
            onClick: () => {
                this.saveEditData();
            }
        },
        {
            label: 'Revert',
            enabled: () => this.editorForm && this.editorForm.$dirty,
            onClick: () => {
                this.editData = _.cloneDeep(CollaboratorsService.originalEditData);
                this.editorForm.$setPristine();
                this.actorIsSelf = _.isEqual(_.get(this.editData, 'character'), 'Self');
            }
        },
        {
            label: 'Close',
            enabled: () => this.editorForm && !this.editorForm.$dirty,
            onClick: () => $location.url(`/meta/${contentPathParam}/edit/${$routeParams.id}/collaborators`)
        }
    ];

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        initializeBreadcrumbs();

        if ($routeParams.actorId === '-1') {
            if (CollaboratorsService.newActor) {
                this.editData = _.cloneDeep(CollaboratorsService.newActor);
                CollaboratorsService.originalEditData = _.cloneDeep(CollaboratorsService.newActor);
            } else {
                $location.url('/login');
            }
        } else {
            getData();
        }
    };

    this.$postLink = () => {
        $timeout(() => {
            this.editorForm.$setPristine();
            CollaboratorsService.editorForm = this.editorForm;
            BreadcrumbService.editService = CollaboratorsService;
        });
    };

    this.$onDestroy = () => {
        BreadcrumbService.clearBreadcrumbs();
        this.editData = null;
        CollaboratorsService.newActor = null;
        CollaboratorsService.editData = null;
        CollaboratorsService.originalEditData = null;
    };

    this.changeActorForRole = () => {
        CollaboratorsService.originalEditData = _.cloneDeep(this.editData);
        CollaboratorsService.newActor = this.editData;
        this.editorForm.$setDirty();
        ModalService.showAddCollaboratorModal([], 'actors', handleNewActorSelection, undefined, !this.isSeason, this.isSeries, false, false);

    };
    const handleNewActorSelection = (collaborators: JS5Object) => {
        _.set(this, 'editData.collaborator', collaborators[0]);
    };
}

angular.module('prism-ui.components').component('actorEditView', {
    templateUrl: 'components/collaborators/roles/actor-edit-view-template.html',
    controller: ActorEditViewController,
    bindings: {
        contentName: '<',
        isSeries: '<'
    }
});
